import { Link, navigate } from "gatsby";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { LANGUAGE } from "../../../../../company/settings/translations";
import { getSlugWithLang } from "../../Shared/Utils/getSlugWithLang";

interface PostItem {
  slug: string;
  name: string;
  author: string;
  description: string;
  searcherString: string;
}
const SearchPopup: React.FC<{ toggleModal: () => void }> = (props: {
  toggleModal: () => void;
}) => {
  const [matchingProduct, setMatchingProduct] = useState<
    PostItem[] | undefined
  >(undefined);
  const [allPost, setAllPost] = useState<PostItem[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState<PostItem | null>(null);

  const { i18n, t } = useTranslation("global");

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
    const fetchData = async () => {
      try {
        const response = await fetch(
          `/searcher/post-list-${i18n.language}.json`,
        );
        const posts = await response.json();
        setAllPost(posts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!matchingProduct || matchingProduct.length === 0) return;
    setSelectedOption(matchingProduct[0]);
  }, [matchingProduct]);
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    if (inputValue === "") {
      setMatchingProduct(undefined);
      return;
    }

    const exactMatchOption = allPost.filter((item) =>
      item.searcherString.toLowerCase().includes(inputValue.toLowerCase()),
    );

    const matchingOptions = allPost.filter((item) => {
      const inputChars = inputValue.toLowerCase().split("");
      const postChars = item.searcherString.toLowerCase().split("");

      const charCounts: { [key: string]: number } = {};
      inputChars.forEach((char: string) => {
        charCounts[char] = charCounts[char] ? charCounts[char] + 1 : 1;
      });

      const meetsCriteria = Object.entries(charCounts).every(
        ([char, count]: [string, number]) => {
          const productCharCount = postChars.filter((c) => c === char).length;
          return productCharCount >= count;
        },
      );

      return meetsCriteria;
    });

    for (const elemento of matchingOptions) {
      if (!exactMatchOption.includes(elemento)) {
        exactMatchOption.push(elemento);
      }
    }

    setMatchingProduct(exactMatchOption);
  }, [inputValue]);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    if (!selectedOption) return;
    navigate(getSlugWithLang(selectedOption.slug, i18n.language as LANGUAGE));
  }

  return (
    <div className={`m-search-popup`}>
      <form className={"search-popup__form"} onSubmit={(e) => handleSubmit(e)}>
        <label className={"search-popup__label"}>Buscador</label>
        <input
          type="text"
          className={"a-input"}
          value={inputValue}
          onChange={handleInputChange}
          placeholder={t("Búscar artículos o proyectos")}
          ref={inputRef}
        />
        {inputValue && (
          <div>
            <div>
              <label hidden>
                <select
                  value={selectedOption?.slug || ""}
                  onChange={(e) =>
                    setSelectedOption({
                      name: "name",
                      slug: e.target.value,
                      author: "",
                      description: "",
                      searcherString: "",
                    })
                  }
                >
                  {matchingProduct && matchingProduct.length > 0 ? (
                    matchingProduct.map((item: PostItem, index: number) => (
                      <option key={index} value={item.slug}>
                        {item.name}
                      </option>
                    ))
                  ) : (
                    <option value="">No hay coincidencias</option>
                  )}
                </select>
              </label>
              <div className={"search-popup__result-n-submit"}>
                <span className={"search-popup__selected"}>
                  {matchingProduct && matchingProduct.length > 0
                    ? selectedOption?.name
                    : " No hay coincidencias"}
                </span>
                <button className={"m-button m-button--white"} type="submit">
                  {t("Ver artículo")}
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
      {matchingProduct && matchingProduct.length > 1 && (
        <div className={"search-popup"}>
          <label className={"search-popup__results"}>
            {t("Más Resultados")}
          </label>
          <ul className={"search-popup__ul"}>
            {matchingProduct.map((item: PostItem, index: number) => (
              <li
                key={index}
                className={"search-popup__item"}
                onClick={() => {
                  navigate(
                    getSlugWithLang(item.slug, i18n.language as LANGUAGE),
                  );
                }}
              >
                <Link
                  className={"search-popup__link"}
                  to={getSlugWithLang(item.slug, LANGUAGE.ES)}
                >
                  {item.name}
                </Link>
                <p className={"search__description"}>
                  {item.description}
                  <br />
                  <b>Por {item.author}</b>
                </p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchPopup;
